// extracted by mini-css-extract-plugin
module.exports = {"overflow_auto":"scroll_overflow_auto__Pa4OG","scrollbar":"scroll_scrollbar__q51Gz"};